export const ASSET_MODAL_CONTENT_CONTROLS_CONDENSED_WIDTH = 760;

export const getIsAssetModalContentControlsCondensed = (centerContentWidth: number) =>
  centerContentWidth > 0 && centerContentWidth <= ASSET_MODAL_CONTENT_CONTROLS_CONDENSED_WIDTH;
